module.exports = __webpack_public_path__ + "img/P11.32c37527.jpg";